"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyResponses = void 0;
var common_1 = require("../common");
var TaxonomyResponses;
(function (TaxonomyResponses) {
    var ViewTaxonomyGroupResponse = /** @class */ (function (_super) {
        __extends(ViewTaxonomyGroupResponse, _super);
        function ViewTaxonomyGroupResponse(
        /**
         * Taxonomy group
         */
        taxonomy, 
        /**
         * Response
         */
        response, isDeveloperMode) {
            var _this = _super.call(this, response, isDeveloperMode) || this;
            _this.taxonomy = taxonomy;
            return _this;
        }
        return ViewTaxonomyGroupResponse;
    }(common_1.BaseKontentResponseStandardDebug));
    TaxonomyResponses.ViewTaxonomyGroupResponse = ViewTaxonomyGroupResponse;
    var ListTaxonomyGroupsResponse = /** @class */ (function (_super) {
        __extends(ListTaxonomyGroupsResponse, _super);
        function ListTaxonomyGroupsResponse(
        /**
         * Taxonomies
         */
        taxonomies, 
        /**
         * Pagination
         */
        pagination, 
        /**
         * Response
         */
        response, isDeveloperMode) {
            var _this = _super.call(this, response, isDeveloperMode) || this;
            _this.taxonomies = taxonomies;
            _this.pagination = pagination;
            return _this;
        }
        return ListTaxonomyGroupsResponse;
    }(common_1.BaseKontentResponseStandardDebug));
    TaxonomyResponses.ListTaxonomyGroupsResponse = ListTaxonomyGroupsResponse;
})(TaxonomyResponses = exports.TaxonomyResponses || (exports.TaxonomyResponses = {}));
//# sourceMappingURL=responses.js.map